import type {ReactAction} from '@netx/core/bootstrap';
import {faCheck} from '@netx/core-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
// import {canAddAssetToCart} from '../enablers';
import {CartAssetActionLabel} from '../locales';
import {CART_ASSET_EVENT} from './constants';

/**
 * Toggle asset in current cart
 * @param params
 * @returns Action
 */
export const cartAssetActionToggle = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-asset-toggle',
	cb: () => {
		dispatcher.trigger(
			!params.selected
				? CART_ASSET_EVENT.ADD_TO_CART
				: CART_ASSET_EVENT.REMOVE_FROM_CART,
			asset.assetId,
			true,
		);
	},
	icon: faCheck,
	get label() {
		return CartAssetActionLabel.TOGGLE_IN_CART;
	},
	...params,
});

export default cartAssetActionToggle;
